export default {
  props: {
    /**
      * Icon format (type of file/string)
      * char - A typed character or emoji
      * svg - SVG file/extract used as icon
      * png - PNG file/extract used as icon
      */
    iconFormat: {type: String, default: 'char'}
  }
};
